import { api } from "../../../lib/api";
import { getAuthToken } from "../../../lib/auth";
import { toast } from "../../../lib/ui";
import type { useSpaces } from "./useSpaces";

const fq = (vId: string, cId: string) => (cId.includes(':') ? cId : `${vId}:${cId}`);

/** Sets the current space's home (default) channel. */
export function useDefaultChannel({
  currentVoidId,
  setVoids,
}: {
  currentVoidId: string;
  setVoids: ReturnType<typeof useSpaces>["setVoids"];
}) {
  async function setDefaultChannel(channelId: string) {
    const sid = currentVoidId;
    if (!sid || sid.startsWith('dm_')) return;
    const tok = getAuthToken() || '';
    if (!tok) return;
    const fqid = fq(sid, channelId);
    try {
      await api.patchAuth('/spaces', { spaceId: sid, homeChannelId: fqid }, tok);
      setVoids(prev => prev.map(v => v.id === sid ? { ...v, homeChannelId: fqid } : v));
      toast('Default channel updated', 'success');
    } catch (e) {
      const msg = e instanceof Error ? e.message : 'Failed to set default channel';
      toast(msg || 'Failed to set default channel', 'error');
    }
  }
  return { setDefaultChannel };
}
